<template>
    <lb-dialog :value="value" @input="$emit('input', $event)" heading="Flow" width="600"
        data-testid="flow-dialog">
        <template v-slot:body>
            <v-form ref="flowForm">
                <v-row data-testid="flow-dialog__form">
                    <v-col cols="6">
                        <div class="queue-management__dispatch-label mt-5">Document ID</div>
                        <v-text-field v-model="flowObject._id" outlined dense
                            :rules="[rules.required]" class="queue-management__queue-select"
                            data-testid="flow-dialog__document-id" />
                    </v-col>
                    <v-col cols="6">
                        <div class="queue-management__dispatch-label mt-5">Collection Name</div>
                        <v-select v-model="flowObject.collectionName" :items="flowTypes" outlined dense
                            :rules="[rules.required]" class="queue-management__queue-select"
                            data-testid="flow-dialog__collection-select" item-value="value" item-text="name" />
                    </v-col>
                    <v-col cols="6">
                        <div class="queue-management__dispatch-label mt-5">Status</div>
                        <v-select v-model="flowObject.status" :items="statusList" outlined dense
                            :rules="[rules.required]" class="queue-management__queue-select"
                            data-testid="flow-dialog__status-select" />
                    </v-col>
                </v-row>
            </v-form>
        </template>

        <template v-slot:actions>
            <v-spacer></v-spacer>
            <base-button primary label="Submit" :loading="loading" @click="flowSend"
                data-testid="flow-dialog__submit-btn" />
        </template>
    </lb-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'FlowDialog',
    props: {
        value: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            flowObject: {
                _id: '',
                collectionName: '',
                status: '',
            },
            rules: {
                required: v => !!v || 'This field is required',
            },
            statusList: ['Pending', 'In-progress', 'Completed', 'Failed'],
            flowTypes: [
                { name: 'Silk Route Flow Status', value: 'silkroute_flow_state' },
                { name: 'Silk Route Task Status', value: 'silkroute_task_state' },
            ],
        };
    },
    computed: {
        ...mapGetters('varianceanalysis/queuemanagement', ['loading']),
    },
    watch: {
        value(open) {
            if (open) {
                this.flowObject = { _id: '', collectionName: '', status: '' };
                this.$nextTick(() => this.$refs.flowForm && this.$refs.flowForm.resetValidation());
            }
        },
    },
    methods: {
        ...mapActions('varianceanalysis/queuemanagement', ['dispatchFlow']),
        async flowSend() {
            if (!this.$refs.flowForm.validate()) return;
            const success = await this.dispatchFlow(this.flowObject);
            if (success) {
                this.$emit('input', false);
            }
        },
    },
};
</script>
